module.exports = __webpack_public_path__ + "static/media/bill.bfc86e9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bill.svg
// module id = 120
// module chunks = 0